import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .hopper-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;
      width: 100%;
    }

    .hopper-header {
      grid-column: 2 / 8;
      grid-row: 2;
      /* H3 scale on an h2 tag — pinned so the h2 default doesn't apply. */
      font-size: var(--fs-title);
      line-height: var(--lh-title);
      letter-spacing: var(--ls-title);
      /* Design wants 30px to the cards; the grid row gap already gives 15. */
      padding-bottom: calc(15rem / var(--default-rem-px-count));
    }

    .hopper-cards {
      grid-column: 2 / 8;
      grid-row: 3;
      display: grid;
      grid-template-columns: 1fr;
      gap: calc(40rem / var(--default-rem-px-count));
    }

    .hopper-card-image {
      display: block;
    }

    .hopper-card img {
      display: block;
      width: 100%;
      height: auto;
    }

    .hopper-card-footer {
      margin-top: calc(20rem / var(--default-rem-px-count));
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: calc(30rem / var(--default-rem-px-count));
    }

    .hopper-card-text {
      display: flex;
      flex-direction: column;
      gap: calc(16rem / var(--default-rem-px-count));
      color: var(--block-text-color, #222222);
    }

    .hopper-card-title {
      /* H3 scale on a p tag — pinned so the body default doesn't apply. */
      font-size: var(--fs-title);
      line-height: var(--lh-title);
      letter-spacing: var(--ls-title);
    }

    @media (min-width: 600px) {
      .hopper-header {
        grid-column: 2 / 14;
        /* Row gap is 0 at this breakpoint, so carry the full 40px here. */
        padding-bottom: calc(40rem / var(--default-rem-px-count));
      }

      .hopper-cards {
        grid-column: 2 / 14;
        /*
          A nested 12-column grid with the same gutter as the page grid, so
          card edges land on the page grid lines. Two columns here, three at
          the desktop breakpoint; anything past that wraps onto a new row.
        */
        grid-template-columns: repeat(12, 1fr);
        gap: calc(60rem / var(--default-rem-px-count))
          var(--between-column-padding);
      }

      .hopper-card {
        grid-column: span 6;
      }
    }

    @media (min-width: 1024px) {
      .hopper-card {
        grid-column: span 4;
      }

      /* Desktop puts the CTA beside the title rather than under it. */
      .hopper-card-footer {
        flex-direction: row;
        justify-content: space-between;
        align-items: baseline;
        gap: var(--between-column-padding);
      }

      .hopper-card-footer > cta-text {
        align-self: baseline;
      }

      .hopper-card-text {
        flex: 1;
        min-width: 0;
      }
    }
  `,
];
